$(document).ready(function () {
    function processFiles(files, $input) {
        const url = $input.data('url');
        const pin = $('#invoice_upload_pin').val();
        const resultId = $input.data('result');

        if (!files.length || !url) {
            return;
        }

        const formData = new FormData();
        $.each(files, function (i, file) {
            formData.append('files[]', file);
        });

        if (pin !== undefined) {
            formData.append('pin', pin);
            uploadInvoices(formData, url, resultId);
        }
    }

    $(document).on('change', '.invoice-upload-input', function () {
        processFiles(this.files, $(this));
        this.value = '';
    });

    const dropZoneSelector = '.invoice-upload-label, .uploaded-invoices__item--add';

    $(window).on('dragover dragenter drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    $(document).on('dragleave drop', dropZoneSelector, function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).removeClass('is-drag-over');
    });

    $(document).on('drop', dropZoneSelector, function (e) {
        e.preventDefault();
        e.stopPropagation();

        $(this).removeClass('is-drag-over');

        const dt = e.originalEvent.dataTransfer;
        if (dt && dt.files.length) {
            const files = dt.files;
            const $input = $('#invoice_upload_files');

            console.log('Files dropped:', files);
            processFiles(files, $input);
        }
    });

    $(document).on('click', '.invoice-delete-btn', function () {
        const $btn = $(this);
        const url = $btn.data('url');
        const resultId = $btn.data('result');

        $btn.css('opacity', '0.5').prop('disabled', true);

        $.ajax({
            url: url,
            method: 'POST',
            processData: false,
            contentType: false,
            success: function (response) {
                if (response.ok && response.html) {
                    $('#' + resultId).html(response.html);
                }
            },
            error: function () {
                alert('Błąd podczas usuwania faktury.');
                $btn.css('opacity', '1').prop('disabled', false);
            }
        });
    });

    function uploadInvoices(formData, url, resultId) {
        $('.invoice-loader').addClass('is-active');
        $('.invoice-icon').addClass('is-hidden');

        $.ajax({
            url: url,
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                $('.invoice-loader').removeClass('is-active');
                $('.invoice-icon').removeClass('is-hidden');
                if (response.ok && response.html) {
                    $('#' + resultId).html(response.html);
                }
            },
            error: function () {
                $('.invoice-loader').removeClass('is-active');
                $('.invoice-icon').removeClass('is-hidden');
                alert('Wystąpił błąd podczas przesyłania plików.');
            }
        });
    }
});